"use client"
import styles from "./Button.module.css"

const Button = ({
  children,
  variant = "primary",
  size = "md",
  disabled = false,
  onClick,
  type = "button",
  className = "",
  ...props
}) => {
  const buttonClasses = [styles.button, styles[variant], styles[size], className].filter(Boolean).join(" ")

  return (
    <button type={type} className={buttonClasses} disabled={disabled} onClick={onClick} {...props}>
      {children}
    </button>
  )
}

export default Button
